export default __webpack_public_path__ + "static/media/canine.91a9e2ea.svg";